import Swiper from 'swiper/bundle';

// Set default Swiper options
const defaultSwiperOptions = {
  direction: 'horizontal',
  slidesPerView: 1,
  spaceBetween: 30,
  speed: 500,
  loop: true,
  centeredSlidesBound: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  slideVisibleClass: 'swiper-slide-visible',
  a11y: {
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
    firstSlideMessage: 'First slide',
    lastSlideMessage: 'Last slide'
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
};

// Initializes a Swiper instance on the given element with the provided options
function initializeSwiper(swiperContainer, additionalOptions) {
  const options = { ...defaultSwiperOptions, ...additionalOptions };
  return new Swiper(swiperContainer, options);
}

function initializeSwiperInstances() {
  const articleListingCards = initializeSwiper('.article-listing.design-cards .swiper .swiper-outer-container', {
    breakpoints: {
      1400: {
        slidesPerView: 3,
        spaceBetween: 115,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 46,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 46,
      }
    }
  });

  const articleListingNotCards = initializeSwiper('.article-listing:not(.design-cards) .swiper .swiper-outer-container', {
  });

  const calloutCarouselAlways = initializeSwiper('.callout .swiper .swiper-outer-container', {
    breakpoints: {
      1400: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2
      }
    }
  });

  const stats = initializeSwiper('.stats .swiper .swiper-outer-container', {
    breakpoints: {
      1400: {
        slidesPerView: 5
      },
      1200: {
        slidesPerView: 4
      },
      768: {
        slidesPerView: 2
      }
    }
  });

}

document.addEventListener('DOMContentLoaded', (event) => {
  initializeSwiperInstances();
});
